import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/profile/arrow_right_white45.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "card_content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "sub_text"
}

import { ref } from 'vue'
import { useRouter } from 'vue-router';
import { inject } from 'vue'
import { clickOnMenu, MENU_LIST } from '@/view/profile/supportScript';
import ContactServicePopup from '@/view/profile/contactServicePopup.vue';
import { useActivityStore } from '@/stores/activity';

export default /*@__PURE__*/_defineComponent({
  __name: 'menuCard',
  emits: ['logout'],
  setup(__props, { emit: __emit }) {

const activityStore = useActivityStore()
const router = useRouter();
const menuList = ref(MENU_LIST)
const emits = __emit
const contactServiceRef = ref()
const poppingIndex = ref<number | null>(null)

const openLogoutPopup = inject<() => void>('openLogoutPopup')

const handleLogoutClick = () => {
    openLogoutPopup?.()
}
const checkMenuShow = (index: number) => {
    if (index === 2) {
        const isAvailableRedeem = activityStore.activityList.some((obj:any) => obj.name === "redeem_code")
        if (isAvailableRedeem) {
            return true
        } else {
            return false
        }
    }

    return true
}
const onMenuClick = (path: string | null, index: number) => {
    clickOnMenu(router, poppingIndex, contactServiceRef, handleLogoutClick, path, index)
}


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            (checkMenuShow(index))
              ? (_openBlock(), _createBlock(_component_van_row, {
                  key: 0,
                  class: _normalizeClass(["row", { 'pop-animate': poppingIndex.value === index }]),
                  onClick: ($event: any) => (onMenuClick(item.path, index))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_col, {
                      span: "2",
                      class: "icon_image"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: item.img,
                          alt: ""
                        }, null, 8, _hoisted_3)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_col, {
                      span: "19",
                      offset: "1",
                      class: "row_text"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, _toDisplayString(_ctx.$t(item.name)), 1),
                        (item.msg)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t(item.msg)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_col, {
                      span: "2",
                      class: "icon"
                    }, {
                      default: _withCtx(() => _cache[0] || (_cache[0] = [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: ""
                        }, null, -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["class", "onClick"]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _createVNode(ContactServicePopup, {
      ref_key: "contactServiceRef",
      ref: contactServiceRef
    }, null, 512)
  ], 64))
}
}

})